<script setup>
/* global axios */
// Icerik > Icerikler: butun gonderiler, tek listede.
//
// BIR GONDERI -> COK HESAP oldugu icin her satir iki katmanli: ustte
// gonderinin OZET durumu, altta her hesabin KENDI sonucu. Instagram'a gidip
// Facebook'a gitmemek olagan bir sonuctur; tek bir durum rozeti bunu
// anlatamaz ve kullanici sorunu goremeden duzeltemez.
//
// Bu bilesen "Taslaklar" ve "Onaylar" ekranlarinin da govdesi. Ayni liste
// mantigini uc kez yazmak yerine `sabitDurum` ile suzup `kip` ile bos durum
// metinlerini degistiriyoruz; satir sonuna eklenecek ozel dugmeler
// `satirIslemleri` yuvasindan geliyor (Onaylar ekrani Onayla/Reddet'i oraya
// koyuyor).
//
// Ham 'axios' PAKETINI ice aktarmiyoruz. Chatwoot kimlik basliklarini
// window.axios uzerinde tutuyor; paketten gelen ornek 401 doner.
import { computed, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import Button from 'dashboard/components-next/button/Button.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import {
  DURUM_ANAHTARLARI,
  DURUM_RENKLERI,
  HEDEF_DURUM_ANAHTARLARI,
  HEDEF_DURUM_RENKLERI,
  PLATFORM_ANAHTARLARI,
  SUZGEC_SECENEKLERI,
  duzenlenebilir,
  hataMetniniCoz,
  hedefAnahtari,
  platformSimgesi,
  silinebilir,
  zamanMetni,
} from './icerik-ortak';

const props = defineProps({
  // Bos degilse durum suzgeci KILITLI: ekran zaten tek bir durumu gosteriyor
  // (Taslaklar, Onaylar). Kullaniciya degistirebilecegi bir suzgec gostermek,
  // degistirince ekranin adiyla celismesi demekti.
  sabitDurum: { type: String, default: '' },
  // 'liste' | 'taslak' | 'onay' - yalnizca bos durum metinlerini secer.
  kip: { type: String, default: 'liste' },
});

const { t, locale } = useI18n();
const route = useRoute();
const router = useRouter();

const accountId = computed(() => route.params.accountId);
const uc = computed(() => `/api/v1/accounts/${accountId.value}/icerik`);

// Bos durum metinleri kipe gore. Anahtarlar ACIK yazilir: uretilen anahtarlar
// aramada bulunamiyor ve eksik ceviri fark edilmeden kaliyor.
const BOS_METINLER = {
  liste: { baslik: 'ICERIK.BOS_BASLIK', aciklama: 'ICERIK.BOS_ACIKLAMA' },
  taslak: {
    baslik: 'ICERIK.TASLAK_BOS_BASLIK',
    aciklama: 'ICERIK.TASLAK_BOS_ACIKLAMA',
  },
  onay: {
    baslik: 'ICERIK.ONAY_BOS_BASLIK',
    aciklama: 'ICERIK.ONAY_BOS_ACIKLAMA',
  },
};

// --- suzgecler -------------------------------------------------------------

// Genel Bakis kartlari buraya `?durum=` ile geliyor. Baslangic degerini
// KURULUM aninda okuyoruz, onMounted'da degil: sonradan atarsak suzgec
// izleyicisi tetiklenir ve ayni liste iki kez cekilir.
//
// Sabit durumlu ekranlarda adresten gelen durum YOK SAYILIR: Taslaklar
// ekranini adresle baska bir duruma cevirmek, basligi ile icerigi celisen bir
// ekran uretirdi.
const baslangicDurumu = () => {
  if (props.sabitDurum) return '';
  const gelen = String(route.query.durum || '');
  return SUZGEC_SECENEKLERI.some(s => s.deger === gelen) ? gelen : '';
};

const durumSuzgeci = ref(baslangicDurumu());
const hesapSuzgeci = ref('');
const basTarihi = ref('');
const bitTarihi = ref('');

const hesaplar = ref([]);

const gonderiler = ref([]);
const toplam = ref(0);
const yukleniyor = ref(true);
const hata = ref('');

// Uzerinde islem suren gonderinin kimligi: ayni dugmeye iki kez basilmasin ve
// hangi satirin beklendigi gorunsun.
const islemdeki = ref(null);

// Uzun metin varsayilan olarak uc satirda kesiliyor; acilan satirlarin
// kimliklerini tutuyoruz. Hepsini acik gostermek listeyi taranamaz yapiyor.
const acikMetinler = ref([]);

const suzgecVar = computed(
  () =>
    (!props.sabitDurum && durumSuzgeci.value !== '') ||
    hesapSuzgeci.value !== '' ||
    basTarihi.value !== '' ||
    bitTarihi.value !== ''
);

const bosMetin = computed(
  () => BOS_METINLER[props.kip] || BOS_METINLER.liste
);

// --- secili gonderi --------------------------------------------------------
//
// Genel Bakis ve Takvim buraya `?gonderi=<id>` ile geliyor. O gonderi acik
// suzgece uymayabilir (ornegin yayinlanmis bir gonderiye taslak suzgeciyle
// gelinmis olabilir); bu yuzden ayrica cekip listenin BASINA koyuyoruz.
// Yoksa kullanici tikladigi seyi bulamadigi bir listeye duserdi.
const seciliKimlik = computed(() => {
  const ham = Number(route.query.gonderi);
  return Number.isNaN(ham) || !ham ? null : ham;
});

const seciliGonderi = ref(null);

const seciliyiYukle = async () => {
  const kimlik = seciliKimlik.value;
  if (!kimlik) {
    seciliGonderi.value = null;
    return;
  }
  try {
    const { data } = await axios.get(`${uc.value}/${kimlik}`);
    seciliGonderi.value = data || null;
  } catch (e) {
    // NEDEN sessiz: gonderi silinmis olabilir. Listenin tamamini bir hata
    // kutusuyla kapatmak, kullanicinin geri kalan icerigini de gizlerdi.
    seciliGonderi.value = null;
  }
};

const secimiTemizle = () => {
  const sorgu = { ...route.query };
  delete sorgu.gonderi;
  router.replace({ query: sorgu });
};

// Listede zaten varsa ikinci kez cizmiyoruz; basa tasiyoruz.
const gosterilenler = computed(() => {
  const secili = seciliGonderi.value;
  if (!secili) return gonderiler.value;
  return [secili, ...gonderiler.value.filter(g => g.id !== secili.id)];
});

// --- veri ------------------------------------------------------------------

const hesaplariYukle = async () => {
  try {
    const { data } = await axios.get(`${uc.value}/hesaplar`);
    hesaplar.value = data.hesaplar || [];
  } catch (e) {
    // Hesap listesi yalnizca suzgec kutusunu dolduruyor. Alinamazsa suzgec
    // bos kalir ama liste calismaya devam eder; ekrani hata ile kapatmak
    // orantisiz olurdu.
    hesaplar.value = [];
  }
};

// Gun secimini YEREL gunun basina / sonuna cevirir. Ham '2026-09-18'
// gondermek sunucuda UTC gece yarisi olarak okunur ve kullanicinin secmedigi
// bir gun listeye girer ya da secilen gunun aksami disarida kalir.
const gunBasi = gun => {
  const [yil, ay, gunNo] = String(gun || '').split('-').map(Number);
  if (!yil || !ay || !gunNo) return null;
  return new Date(yil, ay - 1, gunNo, 0, 0, 0, 0).toISOString();
};

const gunSonu = gun => {
  const [yil, ay, gunNo] = String(gun || '').split('-').map(Number);
  if (!yil || !ay || !gunNo) return null;
  return new Date(yil, ay - 1, gunNo, 23, 59, 59, 999).toISOString();
};

// Suzgec hizli degistiginde gec donen eski yanit yeni listenin uzerine
// yazmasin diye her istege sira numarasi veriyoruz.
let istekSayaci = 0;

const yukle = async () => {
  const sira = (istekSayaci += 1);
  yukleniyor.value = true;
  hata.value = '';

  const params = {};
  const durum = props.sabitDurum || durumSuzgeci.value;
  if (durum) params.durum = durum;
  if (hesapSuzgeci.value) params.inbox_id = hesapSuzgeci.value;
  const bas = gunBasi(basTarihi.value);
  const bit = gunSonu(bitTarihi.value);
  if (bas) params.bas = bas;
  if (bit) params.bit = bit;

  try {
    const { data } = await axios.get(uc.value, { params });
    if (sira !== istekSayaci) return;
    gonderiler.value = data.gonderiler || [];
    toplam.value = Number(data.toplam ?? gonderiler.value.length);
  } catch (e) {
    if (sira !== istekSayaci) return;
    hata.value = hataMetniniCoz(e, t('ICERIK.HATA_BILINMEYEN'));
    gonderiler.value = [];
    toplam.value = 0;
  } finally {
    if (sira === istekSayaci) yukleniyor.value = false;
  }
};

// Bagli hesaplardaki mevcut gonderileri listeye getirir.
//
// NEDEN dugme, otomatik degil: Meta'ya hesap basina istek atiyor. Liste her
// acildiginda calistirmak ekrani bekletir ve hiz sinirini gereksiz yer.
const iceAktariliyor = ref(false);

const iceAktar = async () => {
  iceAktariliyor.value = true;
  try {
    const { data } = await axios.post(`${uc.value}/ice-aktar`);

    // Kismi basari da bir sonuctur: bir hesap patlasa bile digerlerinden
    // gelenler yazildi. Kullaniciya hem sayiyi hem hangi hesabin
    // patladigini soyluyoruz.
    if (data.hatalar?.length) {
      useAlert(
        t('ICERIK.ICE_AKTAR_KISMI', {
          sayi: data.eklenen,
          hesaplar: data.hatalar.map(h => h.ad).join(', '),
        })
      );
    } else {
      useAlert(t('ICERIK.ICE_AKTAR_SONUC', { sayi: data.eklenen }));
    }

    await yenile();
  } catch (e) {
    useAlert(hataMetniniCoz(e, t('ICERIK.HATA_BILINMEYEN')));
  } finally {
    iceAktariliyor.value = false;
  }
};

const yenile = async () => {
  await Promise.all([yukle(), seciliyiYukle()]);
};

onMounted(() => {
  hesaplariYukle();
  yenile();
});

// Suzgec degisince yeniden cekiyoruz; istemcide suzmek 500 satirlik ust
// sinirla birlikte yanlis sonuc verirdi (sunucu zaten kirpilmis liste
// donuyor).
watch([durumSuzgeci, hesapSuzgeci, basTarihi, bitTarihi], yukle);

// Baska bir ekrandan `?gonderi=` ile gelinebilir; adres degisince secili
// gonderiyi tazeliyoruz.
watch(seciliKimlik, seciliyiYukle);

const suzgeciTemizle = () => {
  durumSuzgeci.value = '';
  hesapSuzgeci.value = '';
  basTarihi.value = '';
  bitTarihi.value = '';
};

// --- islemler --------------------------------------------------------------

// Olustur ekrani duzenlenecek gonderiyi `?id=` ile okuyor (IcerikOlustur.vue
// icindeki acilistakiId). Buradaki `?gonderi=` ile karistirmiyoruz: o,
// BU listede hangi satirin one cikacagini soyluyor.
const duzenle = gonderi =>
  router.push({
    name: 'icerik_olustur',
    params: { accountId: accountId.value },
    query: { id: gonderi.id },
  });

// Yayin is kuyrugunda; sonucu gonderiyi yoklayarak ogreniyoruz.
const YOKLAMA_ARALIGI = 2000;
const YOKLAMA_SINIRI = 4 * 60 * 1000;

const yayiniBekle = async id => {
  const bitis = Date.now() + YOKLAMA_SINIRI;
  let son = null;

  while (Date.now() < bitis) {
    await new Promise(c => setTimeout(c, YOKLAMA_ARALIGI));
    try {
      const { data } = await axios.get(`${uc.value}/${id}`);
      son = data;
      if (data.durum !== 'yayinlaniyor') return data;
    } catch {
      // yoksay
    }
  }

  return son;
};

const yayinla = async gonderi => {
  if (!window.confirm(t('ICERIK.YAYINLA_ONAY'))) return;

  islemdeki.value = gonderi.id;
  try {
    // 202: is kuruldu. Yayin arka planda surdugu icin sonucu yokluyoruz;
    // hemen "yayinlandi" demek, daha bitmemis bir isi bitmis gostermek olur.
    await axios.post(`${uc.value}/${gonderi.id}/yayinla`);

    const sonuc = await yayiniBekle(gonderi.id);
    if (sonuc?.durum === 'yayinlandi') useAlert(t('ICERIK.PAYLASILDI'));
    else if (sonuc?.durum === 'kismi') useAlert(t('ICERIK.OLUSTUR.KISMI'));
    else useAlert(t('ICERIK.OLUSTUR.SONUC_HATA_OZET'));
  } catch (e) {
    // Sunucu 'hata' durumunda 422 doner ama gonderiyi de yazar. Uyariyi
    // gosterip listeyi yine tazeliyoruz: kullanici hangi hesapta ne oldugunu
    // satirdaki hedeflerden gormeli.
    useAlert(hataMetniniCoz(e, t('ICERIK.HATA_BILINMEYEN')));
  } finally {
    islemdeki.value = null;
    await yenile();
  }
};

const sil = async gonderi => {
  if (!window.confirm(t('ICERIK.SIL_ONAY'))) return;

  islemdeki.value = gonderi.id;
  try {
    await axios.delete(`${uc.value}/${gonderi.id}`);
    useAlert(t('ICERIK.SILINDI'));
    // Silinen gonderi adreste secili kalirsa liste onu bos yere aramaya
    // devam eder.
    if (seciliKimlik.value === gonderi.id) secimiTemizle();
    await yenile();
  } catch (e) {
    useAlert(hataMetniniCoz(e, t('ICERIK.HATA_BILINMEYEN')));
  } finally {
    islemdeki.value = null;
  }
};

// --- gorunum yardimcilari --------------------------------------------------

// Meta'dan okunan gonderi: Omnup yayinlamadi, yalnizca gosteriyor.
const metadanMi = g => g.secenekler?.kaynak === 'meta';

// Ice aktarilan gonderide kutuphane kaydi yok; onizleme Meta'nin adresi.
// Bu adres zamanla gecersizlesebiliyor, o yuzden yuklenemezse gizliyoruz.
const kaynakGorseli = g => g.secenekler?.kaynak_gorsel || '';

// Satirin solundaki kapak. Omnup'ta hazirlanan gonderide kutuphanedeki ilk
// gorsel, hesaptan getirilen gonderide Meta'nin onizleme adresi.
const kapak = g =>
  g.medya?.find(x => x.tur === 'gorsel' && x.url)?.url || kaynakGorseli(g);

// Kapak zaten solda duruyor; ayni gorseli bir de serit halinde tekrarlamak
// gereksiz. Serit yalnizca FAZLADAN dosya varsa cikiyor.
const ekMedya = g => {
  const hepsi = g.medya || [];
  if (!hepsi.length) return [];

  const kapakAdresi = kapak(g);
  const ilk = hepsi.findIndex(x => x.url && x.url === kapakAdresi);
  return ilk === -1 ? hepsi : hepsi.filter((_, i) => i !== ilk);
};
const gorselHatasi = ref(new Set());
const gorseliGizle = id => {
  gorselHatasi.value = new Set(gorselHatasi.value).add(id);
};

const durumMetni = g => t(DURUM_ANAHTARLARI[g.durum] || 'ICERIK.DURUM_TASLAK');
const durumRengi = g => DURUM_RENKLERI[g.durum] || DURUM_RENKLERI.taslak;

const hedefDurumMetni = h =>
  t(HEDEF_DURUM_ANAHTARLARI[h.durum] || 'ICERIK.HEDEF_BEKLIYOR');
const hedefRengi = h =>
  HEDEF_DURUM_RENKLERI[h.durum] || HEDEF_DURUM_RENKLERI.bekliyor;

// Platform simgesi tek basina anlasilmayabilir (ozellikle ekran okuyucuda).
// Tanimadigimiz bir platform gelirse sunucunun yazdigi ham adi gosteriyoruz:
// bos birakmak "bu nereye gitti" sorusunu cevapsiz birakirdi.
const platformMetni = hedef =>
  PLATFORM_ANAHTARLARI[hedef.platform]
    ? t(PLATFORM_ANAHTARLARI[hedef.platform])
    : hedef.platform || '';

const zaman = deger => zamanMetni(deger, locale.value);

// Satirda hangi zamani yazalim? Yayinlanmis gonderide yayin ani, planlida
// plan ani, taslakta olusturulma ani anlamli. Tek bir alan yazmak, satirlarin
// cogunda yanlis zamani gostermek olurdu.
const zamanSatiri = gonderi => {
  if (gonderi.yayin_zamani) {
    return ['yayinlandi', 'kismi', 'hata'].includes(gonderi.durum)
      ? t('ICERIK.ZAMAN_YAYINLANDI', { zaman: zaman(gonderi.yayin_zamani) })
      : t('ICERIK.ZAMAN_PLANLANDI', { zaman: zaman(gonderi.yayin_zamani) });
  }
  return t('ICERIK.ZAMAN_OLUSTURULDU', { zaman: zaman(gonderi.olusturulma) });
};

const metniAc = kimlik => {
  acikMetinler.value = acikMetinler.value.includes(kimlik)
    ? acikMetinler.value.filter(k => k !== kimlik)
    : [...acikMetinler.value, kimlik];
};

const metinAcik = kimlik => acikMetinler.value.includes(kimlik);

// Metin uzun mu? Kisa gonderide "devamini goster" dugmesi gostermek,
// tiklandiginda hicbir sey degistirmeyen bir dugme olurdu.
const UZUN_METIN = 220;
const metinUzun = gonderi => String(gonderi.metin || '').length > UZUN_METIN;

// Yayin dugmesi hangi durumlarda?
//
// 'onay_bekliyor' BILEREK DISARIDA: sunucu izin verse de buradan yayinlamak
// onay akisini es gecmek olurdu - onayin tek anlami bu. Yonetici onaylamak
// istiyorsa Onaylar ekraninda onaylar, gonderi zaten kendiliginden cikar.
const YAYINLANABILIR_DURUMLAR = ['taslak', 'planlandi', 'hata', 'kismi'];
const yayinlanabilir = gonderi =>
  YAYINLANABILIR_DURUMLAR.includes(gonderi.durum) &&
  (gonderi.hedefler || []).length > 0;
</script>

<template>
  <div class="flex flex-col gap-4 p-6">
    <!-- Suzgec bandi: denetimler tek kutuda, sayac ve islemler sagda. -->
    <div
      class="flex flex-wrap items-end gap-x-3 gap-y-2 p-3 border rounded-xl border-n-weak bg-n-alpha-1"
    >
      <label v-if="!sabitDurum" class="flex flex-col gap-1">
        <span class="text-xs text-n-slate-11">{{ t('ICERIK.SUZGEC') }}</span>
        <select
          v-model="durumSuzgeci"
          class="h-9 px-2.5 text-sm border rounded-lg border-n-weak bg-n-solid-1 text-n-slate-12"
        >
          <option value="">{{ t('ICERIK.DURUM_HEPSI') }}</option>
          <option
            v-for="secenek in SUZGEC_SECENEKLERI"
            :key="secenek.deger"
            :value="secenek.deger"
          >
            {{ t(secenek.anahtar) }}
          </option>
        </select>
      </label>

      <!-- Hic bagli hesap yoksa bu suzgec tek secenekli bos bir kutu olurdu;
           hic gostermiyoruz. -->
      <label v-if="hesaplar.length" class="flex flex-col gap-1">
        <span class="text-xs text-n-slate-11">{{ t('ICERIK.SUZGEC_HESAP') }}</span>
        <select
          v-model="hesapSuzgeci"
          class="h-9 px-2.5 text-sm border rounded-lg border-n-weak bg-n-solid-1 text-n-slate-12"
        >
          <option value="">{{ t('ICERIK.HESAP_HEPSI') }}</option>
          <option
            v-for="hesap in hesaplar"
            :key="hesap.inbox_id"
            :value="hesap.inbox_id"
          >
            {{ hesap.ad }}
          </option>
        </select>
      </label>

      <label class="flex flex-col gap-1">
        <span class="text-xs text-n-slate-11">{{ t('ICERIK.SUZGEC_BAS') }}</span>
        <input
          v-model="basTarihi"
          type="date"
          :max="bitTarihi || undefined"
          class="h-9 px-2.5 text-sm border rounded-lg border-n-weak bg-n-solid-1 text-n-slate-12"
        />
      </label>

      <label class="flex flex-col gap-1">
        <span class="text-xs text-n-slate-11">{{ t('ICERIK.SUZGEC_BIT') }}</span>
        <input
          v-model="bitTarihi"
          type="date"
          :min="basTarihi || undefined"
          class="h-9 px-2.5 text-sm border rounded-lg border-n-weak bg-n-solid-1 text-n-slate-12"
        />
      </label>

      <Button
        v-if="suzgecVar"
        size="sm"
        variant="ghost"
        color="slate"
        icon="i-lucide-x"
        :label="t('ICERIK.SUZGEC_TEMIZLE')"
        @click="suzgeciTemizle"
      />

      <span class="grow" />

      <span class="text-xs whitespace-nowrap text-n-slate-11">
        {{ t('ICERIK.SAYI', { sayi: toplam }) }}
      </span>
      <span class="w-px h-5 bg-n-weak" aria-hidden="true" />
      <Button
        size="sm"
        variant="faded"
        icon="i-lucide-download"
        :label="t('ICERIK.ICE_AKTAR')"
        :is-loading="iceAktariliyor"
        :disabled="yukleniyor || iceAktariliyor"
        @click="iceAktar"
      />
      <Button
        size="sm"
        variant="faded"
        icon="i-lucide-refresh-cw"
        :label="t('ICERIK.YENILE')"
        :disabled="yukleniyor"
        @click="yenile"
      />
    </div>

    <!-- Sunucu listeyi 500 satirda kirpiyor. Sessizce kirpmak, kullaniciya
         "hepsi bu" yalanini soylemek olurdu. -->
    <p
      v-if="toplam > gonderiler.length && !yukleniyor && !hata"
      class="text-xs text-n-amber-11"
    >
      {{ t('ICERIK.KIRPILDI', { gosterilen: gonderiler.length, toplam }) }}
    </p>

    <div v-if="yukleniyor" class="flex justify-center p-10">
      <Spinner class="text-n-brand" />
    </div>

    <div v-else-if="hata" class="flex flex-col items-start gap-3">
      <p class="text-sm text-n-ruby-11">{{ hata }}</p>
      <Button
        size="sm"
        variant="faded"
        icon="i-lucide-refresh-cw"
        :label="t('ICERIK.YENIDEN_DENE')"
        @click="yenile"
      />
    </div>

    <!-- Iki ayri bos durum: hic icerik olmamasi ile suzgece uyan icerik
         olmamasi farkli sorunlar, farkli cozumleri var. -->
    <div
      v-else-if="!gosterilenler.length && suzgecVar"
      class="max-w-xl p-10 mx-auto text-center border rounded-lg border-n-weak"
    >
      <p class="text-sm font-medium text-n-slate-12">
        {{ t('ICERIK.SUZGEC_BOS_BASLIK') }}
      </p>
      <p class="mt-1 mb-4 text-xs text-n-slate-11">
        {{ t('ICERIK.SUZGEC_BOS_ACIKLAMA') }}
      </p>
      <Button
        size="sm"
        variant="faded"
        icon="i-lucide-x"
        :label="t('ICERIK.SUZGEC_TEMIZLE')"
        @click="suzgeciTemizle"
      />
    </div>

    <div
      v-else-if="!gosterilenler.length"
      class="max-w-xl p-10 mx-auto text-center border rounded-lg border-n-weak"
    >
      <span
        class="inline-grid mb-3 rounded-full size-10 place-content-center bg-n-alpha-1 text-n-slate-11"
      >
        <span class="i-lucide-image size-5" />
      </span>
      <p class="text-sm font-medium text-n-slate-12">{{ t(bosMetin.baslik) }}</p>
      <p class="mt-1 mb-4 text-xs text-n-slate-11">
        {{ t(bosMetin.aciklama) }}
      </p>
      <Button
        size="sm"
        variant="solid"
        icon="i-lucide-plus"
        :label="t('ICERIK.SEKME_OLUSTUR')"
        @click="
          router.push({ name: 'icerik_olustur', params: { accountId } })
        "
      />
    </div>

    <ul v-else class="flex flex-col gap-3 list-none">
      <li
        v-for="gonderi in gosterilenler"
        :key="gonderi.id"
        class="flex gap-4 p-4 transition-colors border rounded-xl border-n-weak bg-n-solid-1 hover:border-n-slate-6"
        :class="
          seciliKimlik === gonderi.id ? 'ring-1 ring-inset ring-n-brand' : ''
        "
      >
        <!-- Kapak: gonderiyi metninden once gorselinden taniyoruz. -->
        <img
          v-if="kapak(gonderi) && !gorselHatasi.has(gonderi.id)"
          :src="kapak(gonderi)"
          alt=""
          class="object-cover rounded-lg shrink-0 size-24 bg-n-alpha-1"
          @error="gorseliGizle(gonderi.id)"
        />
        <span
          v-else
          class="grid rounded-lg shrink-0 size-24 place-content-center bg-n-alpha-1 text-n-slate-10"
        >
          <span class="i-lucide-image size-6" />
        </span>

        <div class="flex flex-col min-w-0 gap-2 grow">
        <div class="flex flex-wrap items-center gap-2">
          <span
            class="px-2 py-0.5 text-xs rounded-md"
            :class="durumRengi(gonderi)"
          >
            {{ durumMetni(gonderi) }}
          </span>
          <span class="text-xs text-n-slate-11">{{ zamanSatiri(gonderi) }}</span>
          <span
            v-if="metadanMi(gonderi)"
            class="px-2 py-0.5 text-xs rounded-md text-n-slate-11 bg-n-alpha-1"
          >
            {{ t('ICERIK.KAYNAK_META') }}
          </span>
          <span v-if="gonderi.olusturan" class="text-xs text-n-slate-11">
            {{ t('ICERIK.OLUSTURAN', { ad: gonderi.olusturan.ad }) }}
          </span>

          <span class="grow" />

          <Button
            v-if="seciliKimlik === gonderi.id"
            size="xs"
            variant="ghost"
            color="slate"
            icon="i-lucide-x"
            :label="t('ICERIK.SECIMI_TEMIZLE')"
            @click="secimiTemizle"
          />
        </div>

        <!-- Reddedilen gonderi taslaga doner. Sebebi GORUNUR kalmali; yoksa
             hazirlayan neyi duzeltecegini bilemez. -->
        <p
          v-if="gonderi.red_sebebi"
          class="px-3 py-2 text-xs rounded-md text-n-ruby-11 bg-n-alpha-1"
        >
          {{ t('ICERIK.RED_SEBEBI', { sebep: gonderi.red_sebebi }) }}
        </p>

        <div class="min-w-0">
          <p
            class="text-sm whitespace-pre-line text-n-slate-12"
            :class="metinAcik(gonderi.id) ? '' : 'line-clamp-3'"
          >
            {{ gonderi.metin || t('ICERIK.METINSIZ') }}
          </p>
          <button
            v-if="metinUzun(gonderi)"
            type="button"
            class="mt-1 text-xs text-n-slate-11 hover:text-n-slate-12"
            @click="metniAc(gonderi.id)"
          >
            {{
              metinAcik(gonderi.id)
                ? t('ICERIK.DAHA_AZ')
                : t('ICERIK.DAHA_FAZLA')
            }}
          </button>
        </div>

        <!-- Kapaktan ARTAN dosyalar. Tek dosyali gonderide bu serit hic
             cikmiyor; ayni gorseli iki kez gostermek gurultu olurdu. -->
        <div v-if="ekMedya(gonderi).length" class="flex flex-wrap gap-2">
          <template v-for="medya in ekMedya(gonderi)" :key="medya.id">
            <img
              v-if="medya.tur === 'gorsel' && medya.url"
              :src="medya.url"
              :alt="medya.ad || ''"
              class="object-cover rounded size-16 bg-n-alpha-1"
            />
            <span
              v-else
              class="grid rounded size-16 place-content-center bg-n-alpha-1 text-n-slate-11"
              :title="medya.ad || ''"
            >
              <span class="i-lucide-video size-5" />
            </span>
          </template>
        </div>

        <!-- Hedefler: her hesabin KENDI durumu. Bir gonderinin Instagram'a
             gidip Facebook'a gitmemesi olagan; ayri ayri gorunmeli. -->
        <ul
          v-if="gonderi.hedefler && gonderi.hedefler.length"
          class="flex flex-wrap gap-2 list-none"
        >
          <li
            v-for="hedef in gonderi.hedefler"
            :key="hedefAnahtari(hedef)"
            class="flex flex-col gap-1 px-2.5 py-1.5 rounded-md bg-n-alpha-1 min-w-[12rem] max-w-full"
          >
            <span class="flex items-center gap-1.5 text-xs">
              <span
                :class="platformSimgesi(hedef.platform)"
                class="size-3.5 shrink-0 text-n-slate-11"
                :title="platformMetni(hedef)"
              />
              <span class="truncate text-n-slate-12">
                {{ hedef.ad || t('ICERIK.HESAP_SILINMIS') }}
              </span>
              <span class="grow" />
              <span class="shrink-0" :class="hedefRengi(hedef)">
                {{ hedefDurumMetni(hedef) }}
              </span>
            </span>
            <!-- Hata metni KIRMIZI ve acik yazilir, kisaltilmaz. -->
            <span v-if="hedef.hata" class="text-xs text-n-ruby-11">
              {{ hedef.hata }}
            </span>
            <a
              v-else-if="hedef.dis_url"
              :href="hedef.dis_url"
              target="_blank"
              rel="noopener noreferrer"
              class="text-xs underline text-n-blue-11"
            >
              {{ t('ICERIK.DIS_BAGLANTI') }}
            </a>
          </li>
        </ul>

        <!-- Hedefsiz gonderi olagan (once metin yazilir, hesap sonra secilir)
             ama yayinlanamaz; bunu simdi soylemek yayin aninda soylemekten
             iyidir. -->
        <p v-else class="text-xs text-n-amber-11">
          {{ t('ICERIK.HEDEF_YOK') }}
        </p>

        <!-- Ekranlarin kendi ekledigi islemler (Onaylar: onayla/reddet)
             icerigin altinda kaliyor: bunlar satirin ana eylemi. -->
        <div
          v-if="$slots.satirIslemleri"
          class="flex flex-wrap items-center gap-2"
        >
          <slot name="satirIslemleri" :gonderi="gonderi" :yenile="yenile" />
        </div>
        </div>

        <!-- Islemler SAG sutunda. Eskiden kartin dibinde tek basina bir
             satirdi ve sagdaki bosluk bombostu. -->
        <div class="flex flex-col items-stretch gap-1.5 shrink-0">
          <Button
            v-if="duzenlenebilir(gonderi)"
            size="xs"
            variant="faded"
            icon="i-lucide-pen-line"
            :label="t('ICERIK.DUZENLE')"
            :disabled="islemdeki === gonderi.id"
            @click="duzenle(gonderi)"
          />
          <Button
            v-if="yayinlanabilir(gonderi)"
            size="xs"
            variant="faded"
            icon="i-lucide-send"
            :label="t('ICERIK.YAYINLA')"
            :is-loading="islemdeki === gonderi.id"
            :disabled="islemdeki === gonderi.id"
            @click="yayinla(gonderi)"
          />
          <Button
            v-if="silinebilir(gonderi)"
            size="xs"
            variant="ghost"
            color="ruby"
            icon="i-lucide-trash-2"
            :label="t('ICERIK.SIL')"
            :disabled="islemdeki === gonderi.id"
            @click="sil(gonderi)"
          />
        </div>
      </li>
    </ul>
  </div>
</template>
